/**
 * External Dependencies
 */
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import 'jquery';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';




$(() => {

    $('.uc-ui-show-second-layer a').on('click', function(e) {
        e.preventDefault();
        if ( typeof UC_UI !== 'undefined' ) {
            UC_UI.showSecondLayer();
        }
    });

    const isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
    $('html').addClass(isTouch ? 'touch' : 'no-touch');

    $('body').on('click', '.quantity > button', (e) => {
        let $elm = $(e.currentTarget),
            $qty = $elm.siblings('input[type="number"]'),
            val_ = $elm.attr('name') == 'qty-minus' ? -1 : 1,
            min = $qty.attr('min'),
            newVal = parseInt($qty.val()) + val_;

        if (newVal >= min) {
            $qty.val(newVal);
            $qty.trigger('change');
        }
    });

    let $wcCartNavItem = $('.wc-cart');
    if ( $wcCartNavItem.length ) {
        let data = {
            'action': 'wc_has_cart_items',
        }
        $.post( woocommerce_params.ajax_url, data, function( response ) {
            if ( response.success && response.data.has_cart_items ) {
                $wcCartNavItem.addClass( 'wc-cart-has-items' );
            } else {
                $wcCartNavItem.removeClass( 'wc-cart-has-items' );
            }
        });
    }

    let $navbarScroll = $('.navbar-scroll');
    if ( $navbarScroll.length ) {
        new SimpleBar($navbarScroll.get(0), {
            autoHide: true,
        });
    }

    $('body').on('click', 'a.checkout-button, button#place_order', function(e) {
        if ( $(this).find('span').length ) {
            $(this).find('span').remove();
        }
        let text = $(this).text();
        $(this).html(`<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> ${text}`).addClass('disabled');
    });

    $(document).on( 'checkout_error', function(e) {
        console.log("checkout error");
        let $buttons = $('a.checkout-button.disabled, button#place_order.disabled');
        if ( $buttons.length ) {
            $buttons.removeClass('disabled').find('.spinner-border').remove();
        }
    });

    $(document).on( 'wc_cart_emptied', function() {
        window.location.reload();
    });

    let updateCheckout = function() {
        let $orderSubmit = $('.place-order.wc-gzd-place-order');
        $orderSubmit.block({
            message: '',
            overlayCSS: {
                background: '#fff',
                opacity: 0.6
            }
        });
    }

    // $(document).on( 'init_checkout', updateCheckout );
    $(document).on( 'update_checkout', updateCheckout );
    if ( $('.place-order.wc-gzd-place-order').length ) {
        updateCheckout();
    }

    $(document).on( 'updated_checkout', function() {
        $('.place-order.wc-gzd-place-order ').unblock();

        if ( $('.woocommerce-invalid').length ) {
            $('#place_order').attr('disabled', true);
        }
    });

    let $billingAddress = $('#billing_address_1, #shipping_address_1');
    if ( $billingAddress.length ) {
        $billingAddress.on( 'change', function( e ) {
            let val = $(this).val();

            if ( val === '' ) {
                return;
            }

            if ( val !== '' && val.match(/ \d+/) === null ) {
                $(this).parents('.form-row').removeClass('woocommerce-validated').addClass('woocommerce-invalid');
                e.stopPropagation();
                $('#place_order').attr('disabled', true);

                if ( !$(this).next('.invalid-feedback').length ) {
                    $(this).after('<div class="invalid-feedback float-start w-auto">Bitte geben Sie eine Hausnummer an</div>' );
                }
            } else if ( val !== '' && val.match(/(packstation|postfil)/i) !== null ) {
                $(this).parents('.form-row').removeClass('woocommerce-validated').addClass('woocommerce-invalid');
                e.stopPropagation();
                $('#place_order').attr('disabled', true);

                if ( !$(this).next('.invalid-feedback').length ) {
                    $(this).after('<div class="invalid-feedback float-start w-auto">Lieferungen an Packstationen oder Postfilialen sind nicht möglich</div>' );
                }
            } else {
                $('#place_order').removeAttr('disabled');
            }
        });

        $billingAddress.each(function(i, el) {
            let $el = $(el);
            if ($el.val() !== '') {
                if ( $el.attr('name').includes('shipping') && !$('#ship-to-different-address-checkbox').is(':checked') ) {
                    return;
                }

                $el.trigger('change');
            }
        });

        $('#ship-to-different-address-checkbox').on('change', function(e) {
            if (!$(this).is(':checked')) {
                $('.shipping_address .woocommerce-invalid').removeClass('woocommerce-invalid');
                $('.shipping_address .woocommerce-invalid-required-field').removeClass('woocommerce-invalid-required-field');
            }
        });
    }

});
